import { useContext } from 'react'
import type { AsideActionPosition } from '~/types/global'
import { AsideActionContext } from '~/utils/contextes'
import { confirmCloseAction } from '../ActionUtils'

export const useCloseAction = (targetPosition?: AsideActionPosition) => {
  const {
    isDirty,
    resetAction,
    resetOnClose,
    setResetOnClose,
    asideAction,
    position
  } = useContext(AsideActionContext)

  return async (forceClose = false) => {
    if (targetPosition !== undefined && position !== targetPosition) {
      return true
    }
    if (asideAction && isDirty && !forceClose) {
      const confirm = await confirmCloseAction()
      if (!confirm) {
        return false
      }
    }
    if (resetOnClose) {
      resetAction()
    }
    setResetOnClose(true)
    return true
  }
}
